import React from "react"
import PropTypes from "prop-types"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import { OverlayTrigger, PopOver } from "@tencent/spaui"
import { connect } from "react-redux"

class CustomerInfo extends React.PureComponent {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    customerId: PropTypes.number,
    mpUserName: PropTypes.string,
    customer: PropTypes.object,
  }

  state = {}

  componentDidMount() {
    const { customerId, customer, webApi } = this.props
    if (!customer && customerId) {
      webApi.getCustomer(customerId).dispatch(ActionTypes.FETCH_CUSTOMER)
    }
  }

  render() {
    const { customerId, mpUserName, customer } = this.props
    if (!customerId) {
      return null
    }

    const name = customer && customer.customerName
    if (name) {
      return (
        <span className={"CustomerId"}>
          <OverlayTrigger trigger="hover" overlay={<PopOver>{name}</PopOver>}>
            <span>{mpUserName || customerId}</span>
          </OverlayTrigger>
        </span>
      )
    } else {
      return <span className={"CustomerId"}>{mpUserName || customerId}</span>
    }
  }
}

function mapStateToProps(state, ownProps) {
  return {
    customer: state.customerRepo[ownProps.customerId],
  }
}

export default withApi(connect(mapStateToProps)(CustomerInfo))
